import * as yup from "yup";

export const FormCompanySchema = yup.object({
  company_name: yup.string().required('Este campo es requerido'),
  company_rnc: yup.string().required('Este campo es requerido'),
  company_phone: yup.string().required('Este campo es requerido'),
  // email: yup.string().email('Ingrese un email valido').required('Este campo es requerido'),
  company_address: yup.string().required('Este campo es requerido'),
  company_url_web: yup.string(),
}).required();
